import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Balcı Mobilya</h3>
          <p>Kaliteli mobilya ve beyaz eşya çözümleri için doğru adres.</p>
          <div className="social-links">
            <a href="https://www.instagram.com/balcimobilyamm?igsh=cXZrbXVidGhid3Bj" className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img width={32} src='../files/instagram.png'></img>
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4>Ürünlerimiz</h4>
          <ul className="footer-links">
            <li><Link to="/mobilya">Mobilya</Link></li>
            <li><Link to="/beyaz-esya">Beyaz Eşya</Link></li>
            <li><Link to="/yatak-baza-baslik">Yatak + Baza + Başlık</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Kurumsal</h4>
          <ul className="footer-links">
            <li><Link to="/kurumsal">Hakkımızda</Link></li>
            <li><Link to="/kurumsal">İletişim</Link></li>
            <li><Link to="/kurumsal">Vizyon & Misyon</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>İletişim</h4>
          <div className="contact-info" style={{ background: 'none', padding: '0px' }}>
            <p>📍 Adres:
            Eyüpsultan / İstanbul</p>
            <p>📞 Telefon: +90 212 625 0334</p>
            <p>✉️ E-posta: info@balcimobilya.com</p>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; 2025 Balcı Mobilya. Tüm hakları saklıdır. Tasarım 
            <Link style={{ color: '#C9A94E', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer" to="https://demirer.net"> Demirer Ajans</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 